import styles from './index.module.scss'
import GoBack from '@view/compoents/goBack/goBack';
import { useNavigate } from 'react-router-dom';
import SelectBtnGroups from '@view/page_v3/components/SelectBtnGroups';

const ProDetailListTop = (props) => {
    const navigate = useNavigate()

    const goBackFunc = () => {
        navigate(-1)
    }

    return (
        <div className={styles.ProDetailListTop}>
            <div className={styles.head}>
                <GoBack goBack={() => goBackFunc()} />
                {/* <div className={styles.project_name}>title</div> */}
            </div>
            <SelectBtnGroups
                getIsSelected={props.getIsSelected}
                setSelectedList={props.setSelectedList}
                selectedList={props.selectedList}
                isSelectedAll={props.isSelectedAll}
                downLoading={props.downLoading}
                selectAll={props.selectAll}
                deleteClick={props.deleteClick}
                downClick={props.downClick}
            />
        </div>
    )
}

export default ProDetailListTop
